module.exports = __webpack_public_path__ + "img/administrador.82540f06.png";